var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6748 23.95C6.18545 23.95 0.924805 18.5886 0.924805 11.975C0.924805 5.36138 6.18545 0 12.6748 0C19.1642 0 24.4248 5.36138 24.4248 11.975C24.4248 18.5886 19.1642 23.95 12.6748 23.95ZM10.9123 10.4183V18.3218C10.9123 19.3143 11.7014 20.118 12.6748 20.118C13.6462 20.118 14.4373 19.3139 14.4373 18.3218V10.4183C14.4373 9.42574 13.6482 8.622 12.6748 8.622C11.7034 8.622 10.9123 9.42608 10.9123 10.4183ZM12.6748 7.4245C13.6482 7.4245 14.4373 6.62025 14.4373 5.62825C14.4373 4.63608 13.6482 3.832 12.6748 3.832C11.7014 3.832 10.9123 4.63608 10.9123 5.62825C10.9123 6.62025 11.7014 7.4245 12.6748 7.4245Z",
    fill: "#E2A400"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Info.04451582.svg";
export { ForwardRef as ReactComponent };